import { render } from "./personalContact.vue?vue&type=template&id=07e06306"
import script from "./personalContact.vue?vue&type=script&lang=js"
export * from "./personalContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__